export const API_URL = 'https://asia-northeast3-heropy-api.cloudfunctions.net/api/todos'
export const headers = {
  "content-type": "application/json",
  "apikey": "FcKdtJs202209",
  "username": "KDT3_JoMinJeong",
}
export const inputEl = document.querySelector('.new-todo')
export const addBtn = document.querySelector('.add-btn')
export const todoListEl = document.querySelector('.todoList')
export const addTodoBtn = document.querySelector('.add-todo')
export const modalCloseBtn = document.querySelector('.modal-close')
export const addTodoListBtn = document.querySelector('.add-btn')
export const stateBtns = document.querySelectorAll('.state')
export const allDeleteBtn = document.querySelector('.all-delete')
export const musicEl = document.querySelector('.music')